import React, { useEffect, useState } from 'react';
import { baseURL } from 'utils/api';
import StripePricingTable from './subscriptions';
import toast from 'react-hot-toast';
import BasicLayout from './components/layout';
import SoftBox from 'components/SoftBox';

export default function UserSubscriptions() {

  const [data, setData] = useState({
    pricingTableId: process.env.REACT_APP_STRIPE_PRICING_TABLE_ID, // Pricing table ID from env
    clientSecret: process.env.REACT_APP_STRIPE_PRICING_TABLE_SECRET, // Will be fetched from API
    publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, // Publishable key from env
  })

  useEffect(() => {
    // Detect if app is running inside iframe / webview
    const isInIframe = window.self !== window.top;

    if (isInIframe) {
      console.warn("Detected WebView or iframe. Redirecting to external browser...");
      const currentUrl = window.location.href;
      window.open(currentUrl, "_blank"); // opens in Safari/Chrome
      return;
    }

    // iOS-specific checks
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isIOS) {
      console.log('iOS device detected, ensuring compatibility mode');
    }

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (!token) {
      toast.error('Token not found');
      return;
    }

    // Use fetch with explicit mode and credentials for better cross-platform support
    fetch(`${baseURL}create/checkout/session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      mode: 'cors', // Explicitly set CORS mode
      credentials: 'omit', // Don't send cookies for better iOS compatibility
    })
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(response => {
        if (response.success) {
          console.log('Successfully fetched client secret');
          setData(prev => ({
            ...prev,
            clientSecret: response.data.clientSecret,
          }));
        } else {
          console.error('API returned error:', response.message);
          toast.error(response.message || 'Failed to fetch subscriptions');
        }
      })
      .catch(err => {
        console.error('Error fetching subscriptions:', err);
        toast.error(`Failed to fetch subscriptions: ${err.message}`);
      });
  }, []);

  return (
    <BasicLayout>
      <SoftBox p={3}>
        {data.pricingTableId && data.publishableKey && data.clientSecret ? (
          <div style={{ width: '100%' }}>
            <StripePricingTable
              pricingTableId={data.pricingTableId}
              clientSecretKey={data.clientSecret}
              publishableKey={data.publishableKey}
            />
          </div>
        ) : (
          <div style={{ 
            padding: '40px', 
            textAlign: 'center',
            minHeight: '400px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div style={{
              border: '3px solid #f3f3f3',
              borderTop: '3px solid #3498db',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              animation: 'spin 1s linear infinite'
            }}></div>
            <p style={{ marginTop: '20px', color: '#666' }}>
              Loading subscription details... Please wait.
            </p>
            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
          </div>
        )}
      </SoftBox>
    </BasicLayout>
  );
}
